export class AuthUtils {
  static composeInitials(firstName: string, lastName?: string): string {
    const firstNameInitial = firstName.length ? firstName[0].toUpperCase() : '';

    if (firstName.length && lastName?.length) {
      const lastNameInitial = lastName[0].toUpperCase();

      return `${firstNameInitial}${lastNameInitial}`;
    }

    return firstNameInitial;
  }

  static parseUTMJson(): { [key: string]: string } {
    const utmRaw = localStorage.getItem('utm') || '{}';
    try {
      const parsed = JSON.parse(utmRaw);
      return typeof parsed === 'object' && parsed !== null ? parsed : {};
    } catch (e) {
      console.error('Failed to parse UTM JSON from localStorage:', e);
      return {};
    }
  }
}
